module.exports = __webpack_public_path__ + "img/Green Malllogo.a85679bc.svg";